import { render, staticRenderFns } from "./Korisnik.vue?vue&type=template&id=4d6ca3d3&scoped=true&"
import script from "./Korisnik.vue?vue&type=script&lang=js&"
export * from "./Korisnik.vue?vue&type=script&lang=js&"
import style0 from "./Korisnik.vue?vue&type=style&index=0&id=4d6ca3d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6ca3d3",
  null
  
)

export default component.exports